module.exports = __webpack_public_path__ + "static/media/AWP_Large.6d758783.svg";